import { useRef, useState } from "react";
import { ZoomIn, ZoomOut, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

const MIN = 0.5, MAX = 6;
const clamp = (z) => Math.min(MAX, Math.max(MIN, z));

export default function ZoomImage({ src, alt = "", className = "" }) {
  const [zoom, setZoom] = useState(1);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const drag = useRef(null);

  const reset = () => { setZoom(1); setPos({ x: 0, y: 0 }); };
  const onWheel = (e) => { e.preventDefault(); setZoom((z) => clamp(z * (e.deltaY < 0 ? 1.15 : 1 / 1.15))); };
  const onDown = (e) => { drag.current = { x: e.clientX - pos.x, y: e.clientY - pos.y }; e.currentTarget.setPointerCapture(e.pointerId); };
  const onMove = (e) => { if (drag.current) setPos({ x: e.clientX - drag.current.x, y: e.clientY - drag.current.y }); };
  const onUp = () => { drag.current = null; };

  return (
    <div className={`relative overflow-hidden select-none ${className}`} data-testid="zoom-image">
      <div className="absolute top-2 right-10 z-10 flex gap-1 rounded-md bg-white/90 p-1 shadow">
        <Button type="button" size="icon" variant="ghost" className="h-7 w-7" onClick={() => setZoom((z) => clamp(z / 1.25))} title="Perkecil" data-testid="zoom-out"><ZoomOut className="h-4 w-4" /></Button>
        <span className="h-7 min-w-[3rem] px-1 flex items-center justify-center text-xs font-semibold text-slate-700" data-testid="zoom-level">{Math.round(zoom * 100)}%</span>
        <Button type="button" size="icon" variant="ghost" className="h-7 w-7" onClick={() => setZoom((z) => clamp(z * 1.25))} title="Perbesar" data-testid="zoom-in"><ZoomIn className="h-4 w-4" /></Button>
        <Button type="button" size="icon" variant="ghost" className="h-7 w-7" onClick={reset} title="Reset" data-testid="zoom-reset"><RotateCcw className="h-4 w-4" /></Button>
      </div>
      <div className="w-full h-full flex items-center justify-center touch-none" style={{ cursor: drag.current ? "grabbing" : "grab" }}
        onWheel={onWheel} onPointerDown={onDown} onPointerMove={onMove} onPointerUp={onUp} onPointerCancel={onUp} onDoubleClick={reset}>
        <img src={src} alt={alt} draggable={false} className="max-w-full max-h-full object-contain"
          style={{ transform: `translate(${pos.x}px, ${pos.y}px) scale(${zoom})`, transition: drag.current ? "none" : "transform 120ms ease-out" }} data-testid="zoom-image-img" />
      </div>
      <p className="absolute bottom-2 left-2 text-[10px] text-white/70 pointer-events-none">Scroll untuk zoom · seret untuk geser · klik 2x untuk reset</p>
    </div>
  );
}
